import { ADD_USER } from "./user.types";

export function addUser(user) {
  return {
    type: ADD_USER,
    user,
  }
}

